import type { CrmFilterTaxonomyOperatorLabel } from "./crmFilterTaxonomy.operators";

/** Repeated source vocabulary, not independent runtime filter definitions. */
export const stateChanges = [
  "Is",
  "Is not",
  "Is any of",
  "Has changed to",
  "Has changed from",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const selection = [
  "Is",
  "Is not",
  "Is any of",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const count = [
  "Greater than",
  "Less than",
  "Equals",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const eventWindow = [
  "Has happened",
  "Has not happened",
  "Is within",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const signedMoney = [
  "Is below",
  "Is above",
  "Has turned positive",
  "Has turned negative",
  "Has dropped below",
  "Has risen above",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const changingNumber = [
  "Is below",
  "Is above",
  "Has dropped below",
  "Has risen above",
  "Has changed by X%",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const booleanState = [
  "Is",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const dates = [
  "Is within",
  "Before",
  "After",
  "Between",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const moneyComparison = [
  "Is below",
  "Is above",
  "Greater than",
  "Less than",
  "Equals",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const optionalSelection = [
  "Is",
  "Is not",
  "Is any of",
  "Is missing",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const businessMoney = [
  "Is below",
  "Is above",
  "Greater than",
  "Less than",
] as const satisfies readonly CrmFilterTaxonomyOperatorLabel[];
export const health = [
  "Not started",
  "Getting started",
  "Engaged",
  "Declining",
] as const;
export const subscription = [
  "No subscription",
  "Trial",
  "Active subscription",
  "Lifetime subscription",
  "Cancelled",
  "Churned",
] as const;
export const pastWindows = [
  "Last 48 hours",
  "Last 7 days",
  "Last 30 days",
  "Last 60 days",
  "Last 90 days",
] as const;
export const noValues = ["—"] as const;
export const dollars = ["Custom dollar amount"] as const;
export const yesNo = ["Yes", "No"] as const;
export const emails = ["Live template and broadcast list"] as const;
export const captured = ["Captured value"] as const;

type SourceField = readonly [
  id: string,
  label: string,
  operators: readonly CrmFilterTaxonomyOperatorLabel[],
  values: readonly string[],
];
export type SourceCategory = {
  readonly id: string;
  readonly number: number;
  readonly label: string;
  readonly fields: readonly SourceField[];
};
